import { z } from "zod";

export const KNOWN_ENTITY_TYPES = ["customer", "carrier", "order", "load", "facility"] as const;

export type KnownEntityType = (typeof KNOWN_ENTITY_TYPES)[number];

export function isKnownEntityType(value: string): value is KnownEntityType {
    return (KNOWN_ENTITY_TYPES as readonly string[]).includes(value);
}

export const EntityCandidateSchema = z.object({
    id: z.string().min(1),
    type: z.string().min(1),
    displayName: z.string().min(1),
    subtitle: z.string().nullable().optional(),
});

export type EntityCandidate = z.infer<typeof EntityCandidateSchema>;

export const EntityCandidatesResponseSchema = z.object({
    items: z.array(EntityCandidateSchema),
});

export type EntityCandidatesResponse = z.infer<typeof EntityCandidatesResponseSchema>;

export const EntityResolveStatusSchema = z.enum([
    "Resolved",
    "NotFound",
    "Unavailable",
    "UnsupportedType",
]);

export type EntityResolveStatus = z.infer<typeof EntityResolveStatusSchema>;

export const EntityResolveResponseSchema = z.object({
    id: z.string(),
    type: z.string(),
    displayName: z.string(),
    subtitle: z.string().nullable().optional(),
    status: EntityResolveStatusSchema,
});

export type EntityResolveResponse = z.infer<typeof EntityResolveResponseSchema>;
